import * as React from 'react'
import { useMediaQuery } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'

import SearchBar from '../../../dashboard/DashboardComponents/SearchBar/SearchBar'
import {
  filterByValue,
  sortListAlphabetically,
  sortParkingListAlphabetically,
} from '../../utils/helpers'
import {
  setSearchValue,
  setSelectedParkingLots,
  setSelectedRoutes,
  setSelectedStops,
} from '../../sections/Map/redux/myMapsSlice'
import { setSelectedCampusBuildings } from '../../sections/Buildings/redux/myBuildingsSlice'
import useMapSearchBarStyles from './MapSearchBarStyles'
import { trackEvent } from '../../../../helpers/analytics'

/**
 * There's an issue with this component. When you move in the isDesktopView and showSearchBar into this component instead of on parent, the UI doesn't look right on mobile.
 */
function MapSearchBar() {
  const dispatch = useDispatch()
  const classes = useMapSearchBarStyles()
  const [tabLabel, setTabLabel] = React.useState('')
  const isDesktopView = useMediaQuery((theme) => theme.breakpoints.up('md'))
  // const isDesktopView = useMediaQuery((theme) => theme.breakpoints.up('md'))
  const searchTrackingTimer = React.useRef(null)
  const { showSearchBar, markerInfo } = useSelector((state) => state.maps)
  const {
    routes,
    stops,
    parkingLotData,
    tabValue,
    mapSearchBottomSheetSelectedTab,
    searchValue,
  } = useSelector((s) => s.maps)

  const { campusBuildings } = useSelector((s) => s.buildings)

  React.useEffect(() => {
    const val = {
      0: 'Routes',
      1: 'Stops',
      2: 'Buildings',
      3: 'Parking Lots',
    }

    const label = `Search ${val[mapSearchBottomSheetSelectedTab]}`
    setTabLabel(label)
  }, [mapSearchBottomSheetSelectedTab])

  React.useEffect(() => {
    if (tabValue === 1) {
      const label = `Search Buildings`
      setTabLabel(label)
    }
  }, [tabValue])

  React.useEffect(() => {
    if (!showSearchBar) {
      cancelSearch()
    }
  }, [showSearchBar])

  const handleSearchBar = (event) => {
    const val = event.target.value
    dispatch(setSearchValue(val))
    if (searchTrackingTimer.current) {
      clearTimeout(searchTrackingTimer.current)
    }
    searchTrackingTimer.current = setTimeout(() => {
      if (val && val.trim()) {
        trackEvent(dispatch, {
          eventName: 'uxp_maps_search',
          module: 'Maps',
          object: 'Search',
          action: 'Submit',
          actionContext: 'MapSearch',
          actionContextValue: val,
        })
      }
    }, 1000)

    // Use the utility function to filter the data
    const filteredRouteList = filterByValue(routes, 'route_long_name', val)
    const filteredStops = filterByValue(stops, 'stop_name', val)
    const filteredParkingList = filterByValue(
      parkingLotData,
      'propertyName',
      val,
    )
    const campusKeys = ['New Brunswick', 'Newark', 'Camden', 'Other']
    const filteredCampusBuildings = {}
    campusKeys.forEach((key) => {
      filteredCampusBuildings[key] = filterByValue(
        campusBuildings[key],
        'name',
        val,
      )
    })

    // Dispatching the filtered data
    dispatch(setSelectedRoutes(filteredRouteList))
    dispatch(setSelectedStops(filteredStops))
    dispatch(setSelectedCampusBuildings(filteredCampusBuildings))
    dispatch(setSelectedParkingLots(filteredParkingList))
    // Handling empty search value
    if (val === '') {
      cancelSearch()
    }
  }

  const cancelSearch = () => {
    dispatch(setSearchValue(''))
    dispatch(setSelectedStops(sortListAlphabetically(stops, 'stop_name')))
    dispatch(
      setSelectedRoutes(sortListAlphabetically(routes, 'route_long_name')),
    )
    dispatch(
      setSelectedCampusBuildings({
        'New Brunswick': sortListAlphabetically(
          campusBuildings['New Brunswick'],
        ),
        Newark: sortListAlphabetically(campusBuildings.Newark),
        Camden: sortListAlphabetically(campusBuildings.Camden),
        Other: sortListAlphabetically(campusBuildings.Other),
      }),
    )
    dispatch(
      setSelectedParkingLots(
        sortParkingListAlphabetically(
          parkingLotData.filter((el) => ![].includes(el)),
        ),
      ),
    )
  }

  return (
    <>
      {showSearchBar && (
        <div
          className={
            // eslint-disable-next-line
            isDesktopView
              ? markerInfo && Object.keys(markerInfo).length !== 0
                ? classes.searchBarContainerWithMapInfo
                : classes.searchBarContainer
              : classes.searchBarContainerMobile
          }
        >
          <SearchBar
            className={
              isDesktopView ? classes.searchBar : classes.searchBarMobile
            }
            value={searchValue}
            onChange={(val) => handleSearchBar(val)}
            onCancelSearch={() => cancelSearch()}
            placeholder={tabLabel}
            moduleName="myMaps"
            dispatch={dispatch}
          />
        </div>
      )}
    </>
  )
}

export default MapSearchBar
